'use client';

import React, {
  createContext, useContext, useMemo, useState,
} from 'react';
import { TileFragmentFragment } from '@/integrations/crystallize/__gql-codegen-types/catalogue/graphql';
import { SubnavDataContextType } from './types/SubnavDataContextType';

const SubnavDataContext = createContext<SubnavDataContextType>({
  subnavData: null,
  setSubnavData: () => {},
});

export function SubnavDataProvider({ children }: { children: React.ReactNode }) {
  const [subnavData, setSubnavData] = useState<TileFragmentFragment | null | undefined>(null);

  const subnavContextValue = useMemo(
    () => ({ subnavData, setSubnavData }),
    [subnavData, setSubnavData],
  );

  return (
    <SubnavDataContext.Provider value={subnavContextValue}>{children}</SubnavDataContext.Provider>
  );
}

export function useSubnavData() {
  return useContext(SubnavDataContext);
}
